<div class="m-alert m-alert--air m-alert--square alert alert-dismissible m--margin-bottom-30" [ngClass]="classes" role="alert">
	<div class="m-alert__icon m-alert__icon--top">
		<i [ngClass]="icon"></i>
	</div>
	<div class="m-alert__text">
		<ng-content></ng-content>
	</div>
</div>
